module.exports = __webpack_public_path__ + "static/img/banner.72420ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/h5/banner.png
// module id = dHj5
// module chunks = 0